// extracted by mini-css-extract-plugin
module.exports = {"container":"Loading_container__15xUr","image":"Loading_image__19-JA"};